import React from "react";
import {Button} from "../../../UI/MUIButton";
import {TemplateCreationModal} from "../TemplateCreationModal/TemplateCreationModal";
import {useModalContext} from "../../../contexts/ModalContext/context";
import {PortfolioLifestyleTemplate} from "../../../services/PortfolioApi";

export interface TemplateCreationButtonProps {
    portfolioId: string;
    onTemplateAdd: (template: PortfolioLifestyleTemplate) => void;
}

export const TemplateCreationButton: React.FC<TemplateCreationButtonProps> = ({portfolioId, onTemplateAdd}) => {
    const { setIsOpen } = useModalContext();

    const handleClick = () => {
        setIsOpen(true);
    };

    return (
        <>
            <Button color="primary" onClick={handleClick}>
                Create a new template
            </Button>
            <TemplateCreationModal portfolioId={portfolioId} addTemplate={onTemplateAdd}/>
        </>);
};